import { combineReducers } from 'redux';
import activity from './ducks/userActivity';
import account from './ducks/account';
import myCompany from './ducks/myCompany';

const combinedReducers = combineReducers({
  activity,
  account,
  myCompany
});

export default (state, action) => {
  return combinedReducers(state, action);
};
